import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import api from '../utils/api';

const SpotifyStats = () => {
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fetchSpotify = async () => {
      try {
        const res = await api.get('/spotify/data');
        if (res.data.show) {
          setShow(true);
          setData(res.data);
        }
      } catch (error) {
        console.error('Error fetching Spotify stats:', error);
      }
    };
    fetchSpotify();
  }, []);

  if (!show || !data) return null;

  return (
    <section className="page-section bg-white-custom" id="spotify">
      <Container className="px-4 px-lg-5">
        <h2 className="text-center mt-0">On Rotation</h2>
        <hr className="divider my-4 bg-primary opacity-100 mx-auto" style={{ width: '100px', height: '3px' }} />
        <p className="text-muted text-center mb-5">What I've been listening to lately on Spotify.</p>

        <Row>
          {/* Top Tracks */}
          <Col md={4} className="mb-4">
            <h3 className="h5 mb-4 text-center text-muted text-uppercase tracking-wider">Top Tracks</h3>
            <ListGroup variant="flush">
              {data.tracks.map((track, index) => (
                <ListGroup.Item key={track.id} className="d-flex align-items-center bg-transparent border-0 mb-3 p-0">
                  <span className="me-3 text-muted fw-bold" style={{ minWidth: '20px' }}>{index + 1}</span>
                  <Image 
                    src={track.album.images[2]?.url} 
                    rounded 
                    width={50} 
                    height={50} 
                    className="me-3 shadow-sm" 
                  />
                  <div className="flex-grow-1 overflow-hidden">
                    <div className="fw-bold text-truncate">
                      <a href={track.external_urls.spotify} target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                        {track.name}
                      </a>
                    </div>
                    <div className="text-muted small text-truncate">
                      {track.artists.map(a => a.name).join(', ')}
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>

          {/* Top Artists */}
          <Col md={4} className="mb-4">
            <h3 className="h5 mb-4 text-center text-muted text-uppercase tracking-wider">Top Artists</h3>
            <ListGroup variant="flush">
              {data.artists.map((artist, index) => (
                <ListGroup.Item key={artist.id} className="d-flex align-items-center bg-transparent border-0 mb-3 p-0">
                  <span className="me-3 text-muted fw-bold" style={{ minWidth: '20px' }}>{index + 1}</span>
                  <Image 
                    src={artist.images[2]?.url || artist.images[0]?.url} 
                    roundedCircle 
                    width={50} 
                    height={50} 
                    className="me-3 shadow-sm"
                    style={{ objectFit: 'cover' }}
                  />
                  <div className="flex-grow-1 overflow-hidden">
                    <div className="fw-bold text-truncate">
                      <a href={artist.external_urls.spotify} target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                        {artist.name}
                      </a>
                    </div>
                    <div className="text-muted small text-truncate text-capitalize">
                      {artist.genres.slice(0, 1).join(', ') || 'Artist'}
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>

          {/* Top Genres */}
          <Col md={4} className="mb-4">
            <h3 className="h5 mb-4 text-center text-muted text-uppercase tracking-wider">Top Genres</h3>
            <ListGroup variant="flush">
              {data.genres.map((genre, index) => (
                <ListGroup.Item key={genre.name} className="d-flex align-items-center bg-transparent border-0 mb-3 p-0">
                  <span className="me-3 text-muted fw-bold" style={{ minWidth: '20px' }}>{index + 1}</span>
                  {/* Use artist image associated with genre, or a placeholder */}
                  <div 
                    className="me-3 shadow-sm rounded-circle d-flex align-items-center justify-content-center bg-light"
                    style={{ width: '50px', height: '50px', overflow: 'hidden' }}
                  >
                    {genre.image ? (
                       <Image src={genre.image} width={50} height={50} style={{ objectFit: 'cover' }} />
                    ) : (
                       <span className="text-muted small">#</span>
                    )}
                  </div>
                  <div className="flex-grow-1">
                    <div className="fw-bold text-capitalize text-dark">
                      {genre.name}
                    </div>
                    <div className="text-muted small">
                      Based on your listening
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SpotifyStats;
